import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import styled from 'styled-components';
import { CTAColors, neutralColors } from '../../styles/colors/colors.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { format } from '../../utils/strings.js';
import { avatarSizeToPixelsMap, AvatarUser } from '../AvatarUser/AvatarUser.js';
import { Circle, circleSizeMap } from '../Circle/Circle.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx } from 'react/jsx-runtime';

var MAX_USER_AVATARS = 5;
var MAX_USERNAMES_IN_TOOLTIP = 3;
var ClusterWrapper = styled.div.withConfig({
  displayName: "AvatarCluster__ClusterWrapper",
  componentId: "sc-1kgyhon-0"
})(["&&{display:flex;flex-direction:row;padding:0;border-radius:100%;border:none;background:none;cursor:pointer;}&&:focus{outline:2px solid ", ";}"], CTAColors.primaryVariant);
var AvatarUserContainer = styled.div.withConfig({
  displayName: "AvatarCluster__AvatarUserContainer",
  componentId: "sc-1kgyhon-1"
})(["&&{", ";}"], function (_ref) {
  var avatarSize = _ref.avatarSize;
  var size = circleSizeMap[avatarSize];
  return "margin-left: -".concat(size * 0.2, "px;\n        :first-child {\n            margin-left: 0;\n        }");
});
var CountCircle = styled(Circle).withConfig({
  displayName: "AvatarCluster__CountCircle",
  componentId: "sc-1kgyhon-2"
})(["&&{z-index:2;background-color:", ";border:1px solid ", ";color:", ";", ";}"], neutralColors.white, neutralColors.silver, neutralColors.smoke, function (_ref2) {
  var size = _ref2.size;
  return "\n        margin-left: -".concat(circleSizeMap[size] * 0.2, "px;\n        font-size: ").concat(avatarSizeToPixelsMap[size].fontSize, "px;\n    ");
});

var getTooltipContent = function getTooltipContent(userNames, i18n) {
  var _i18n$AvatarCluster = i18n.AvatarCluster,
      tooltipContentForSingleUser = _i18n$AvatarCluster.tooltipContentForSingleUser,
      tooltipContentForTwoUsers = _i18n$AvatarCluster.tooltipContentForTwoUsers,
      defaultTooltipContent = _i18n$AvatarCluster.defaultTooltipContent;

  switch (userNames.length) {
    case 1:
      return format(tooltipContentForSingleUser, userNames[0]);

    case 2:
      return format(tooltipContentForTwoUsers, userNames[0], userNames[1]);

    default:
      return format(defaultTooltipContent, userNames[0], userNames[1], userNames[2]);
  }
};

var AvatarCluster = function AvatarCluster(props) {
  var users = props.users,
      _props$size = props.size,
      size = _props$size === void 0 ? "lg" : _props$size,
      tooltipProps = props.tooltipProps,
      onClick = props.onClick;

  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  return /*#__PURE__*/jsx("div", {
    style: {
      display: "inline-block"
    },
    children: /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
      content: getTooltipContent(users.slice(0, MAX_USERNAMES_IN_TOOLTIP).map(function (_ref3) {
        var name = _ref3.name;
        return name;
      }), i18n)
    }, tooltipProps), {}, {
      children: /*#__PURE__*/jsx(ClusterWrapper, {
        as: onClick ? "button" : "div",
        onClick: onClick,
        "aria-label": i18n.AvatarCluster.clusterLabel,
        children: users.map(function (_ref4, i) {
          var src = _ref4.src,
              name = _ref4.name;

          if (i < MAX_USER_AVATARS) {
            return /*#__PURE__*/jsx(AvatarUserContainer, {
              avatarSize: size,
              children: /*#__PURE__*/jsx(AvatarUser, {
                size: size,
                src: src,
                name: name,
                hideToolTip: true
              })
            }, i);
          } else if (i === MAX_USER_AVATARS) {
            return /*#__PURE__*/jsx(CountCircle, {
              size: size,
              children: "+".concat(users.length - MAX_USER_AVATARS)
            }, i);
          }
        })
      })
    }))
  });
};

AvatarCluster.propTypes = {
  "onClick": _PropTypes.func,
  "size": _PropTypes.oneOf(["lg", "md", "sm", "xs"]),
  "tooltipProps": _PropTypes.object,
  "users": _PropTypes.arrayOf(_PropTypes.shape({
    "name": _PropTypes.string,
    "src": _PropTypes.string
  })).isRequired
};
AvatarCluster.displayName = "AvatarCluster";

export { AvatarCluster, ClusterWrapper };
